/* The Saber Company · truthful cart totals
   Discount Ninja draws its own cart summary and the theme hides the native one
   while a DN promotion is active. DN can't see Shopify's native automatic
   discounts (e.g. FREE SABERSTAND), so it can quote a total that checkout does
   not charge. This replaces that summary — on the cart page and in the cart
   drawer — with the numbers Shopify itself reports for the cart, and names each
   discount under the line it applies to.
   Display only: it never changes the cart, the discounts, or what checkout charges.
   To revert: delete this file and its <script> tag in snippets/meta-tags.liquid. */
(() => {
if (window.tscCartTotals) return;
window.tscCartTotals = true;
const SCOPES = '#main-cart-footer, cart-drawer, #CartDrawer, .cart-drawer';
const DN_SUMMARY = '.limoniapps-discountninja-cart-promotionsummary';
const NATIVE_TOTALS = '.totals, .cart-drawer__totals';
const LINE_ROWS = '[data-la-dn-cart-item-key], [id^="CartItem-"], [id^="CartDrawer-Item-"]';
const MIN_GAP = 800;
let timer = 0;
let lastFetch = 0;
let cached = null;

/* /cart.js carries no compare_at_price, so a catalogue markdown (list $159.99,
   selling $111.99) was invisible in the totals - the strikethrough only ever
   showed the pre-discount-code figure. Pull compare-at per product once and
   cache it, then count that markdown as a saving like any other. */
const compareByVariant = new Map();
const productLoads = new Map();

function loadCompare(handle) {
  if (productLoads.has(handle)) return productLoads.get(handle);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const job = fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : null))
    .then((prod) => {
      for (const v of (prod && prod.variants) || []) {
        if (v.compare_at_price && v.compare_at_price > v.price) compareByVariant.set(v.id, v.compare_at_price);
      }
      return true;
    })
    .catch(() => false);
  productLoads.set(handle, job);
  return job;
}

// What the cart would have cost at list price. Returns null while still loading,
// so the totals never flash a half-counted figure.
function compareTotal(cart) {
  let missing = false;
  let sum = 0;
  for (const item of cart.items || []) {
    if (!productLoads.has(item.handle)) {
      loadCompare(item.handle).then(() => schedule(false));
      missing = true;
    }
    const unit = compareByVariant.get(item.variant_id) || item.original_price;
    sum += unit * item.quantity;
  }
  return missing ? null : sum;
}

const locale = (window.Shopify && window.Shopify.locale) || 'en-US';
const money = (cents, currency) => {
try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100); }
catch { return `${(cents / 100).toFixed(2)} ${currency}`; }
};
const esc = (v) => String(v).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

// Line-level allocations plus cart-level applications add up to cart.total_discount.
// If they ever don't, show one honest "Discounts" line instead of guessing.
function discountRows(cart) {
const byTitle = new Map();
const add = (title, amount) => {
if (!amount) return;
const key = title || 'Discount';
byTitle.set(key, (byTitle.get(key) || 0) + amount);
};
for (const item of cart.items || []) {
for (const alloc of item.line_level_discount_allocations || []) {
add(alloc.discount_application && alloc.discount_application.title, alloc.amount);
}
}
for (const d of cart.cart_level_discount_applications || []) add(d.title, d.total_allocated_amount);
const rows = [...byTitle.entries()];
const sum = rows.reduce((total, row) => total + row[1], 0);
if (sum !== cart.total_discount) return cart.total_discount ? [['Discounts', cart.total_discount]] : [];
return rows;
}

// Hide Discount Ninja's summary up front so its numbers never flash on screen,
// then undo that if our own summary hasn't appeared a few seconds in.
function styles() {
if (document.getElementById('tsc-cart-totals-styles')) return;
const el = document.createElement('style');
el.id = 'tsc-cart-totals-styles';
el.textContent = DN_SUMMARY + '{display:none!important}'
+ '.tsc-line-discounts{display:block;margin-top:.3rem;font-size:1.2rem;line-height:1.5;color:#3dff8f}'
+ '.tsc-line-discounts span{display:block;white-space:nowrap}'
+ '.tsc-totals{display:grid;gap:.4rem;margin:1.2rem 0}'
+ '.tsc-totals__row{display:flex;justify-content:space-between;align-items:baseline;gap:1.2rem;font-size:1.4rem}'
+ '.tsc-totals__row--saving span:last-child{color:#3dff8f}'
+ '.tsc-totals__row--total{margin-top:.4rem;padding-top:.8rem;border-top:1px solid rgba(127,127,127,.35);font-size:1.6rem;font-weight:700}'
+ '.tsc-totals__was{opacity:.55;font-weight:500;text-decoration:line-through}';
(document.head || document.documentElement).append(el);
setTimeout(() => {
if (document.querySelector('.tsc-totals')) return;
const style = document.getElementById('tsc-cart-totals-styles');
if (style) style.textContent = style.textContent.replace(DN_SUMMARY + '{display:none!important}', '');
}, 4000);
}

function restore(scope) {
scope.querySelectorAll(DN_SUMMARY).forEach((el) => { el.style.display = ''; });
scope.querySelectorAll(NATIVE_TOTALS).forEach((el) => { if (!el.closest('.tsc-totals')) el.style.display = ''; });
const box = scope.querySelector('.tsc-totals');
if (box) box.remove();
}

function paint(scope, cart) {
if (!cart.item_count) return restore(scope);
scope.querySelectorAll(DN_SUMMARY).forEach((el) => { el.style.display = 'none'; });
scope.querySelectorAll(NATIVE_TOTALS).forEach((el) => { if (!el.closest('.tsc-totals')) el.style.display = 'none'; });

let box = scope.querySelector('.tsc-totals');
if (!box) {
box = document.createElement('div');
box.className = 'tsc-totals';
const cta = scope.querySelector('.cart__ctas, .cart-drawer__ctas, [name="checkout"]');
if (cta && cta.parentElement) cta.parentElement.insertBefore(box, cta);
else scope.append(box);
}
const rows = discountRows(cart)
.map(([title, amount]) => `<div class="tsc-totals__row tsc-totals__row--saving"><span>${esc(title)}</span><span>−${money(amount, cart.currency)}</span></div>`)
.join('');
// No Subtotal line: the discounts and the Total already say what is owed,
// and the drawer is short on vertical space. The pre-discount figure is kept
// as a strikethrough on the Total row so the saving stays visible.
// The strikethrough is what the cart would have cost at list price, so it counts
// the catalogue markdown as well as any discount, not just the discount.
const listTotal = compareTotal(cart);
const wasValue = Math.max(listTotal === null ? 0 : listTotal, cart.original_total_price);
const markdown = (listTotal === null ? 0 : listTotal) - cart.original_total_price;
const markdownRow = markdown > 0
? `<div class="tsc-totals__row tsc-totals__row--saving"><span>Birthday 30% off</span><span>−${money(markdown, cart.currency)}</span></div>`
: '';
const was = wasValue > cart.total_price
? `<s class="tsc-totals__was">${money(wasValue, cart.currency)}</s> `
: '';
const html = markdownRow + rows
+ `<div class="tsc-totals__row tsc-totals__row--total"><span>Total</span><span>${was}${money(cart.total_price, cart.currency)}</span></div>`;
if (box.dataset.html !== html) {
box.innerHTML = html;
box.dataset.html = html;
}
}

// A line-level discount (buy X get Y) is already in the line price, and the theme
// strikes it through. A cart-level one (a % code) is spread across the lines and
// shown nowhere, so name it and its share under each line's price.
function paintLines(cart) {
const byKey = new Map((cart.items || []).map((i) => [i.key, i]));
for (const row of document.querySelectorAll(LINE_ROWS)) {
const key = row.getAttribute('data-la-dn-cart-item-key');
let item = key ? byKey.get(key) : null;
if (!item) {
const match = /(\d+)$/.exec(row.id || '') || [];
const index = Number(match[1] || row.getAttribute('data-index')) - 1;
item = Number.isInteger(index) && index >= 0 ? (cart.items || [])[index] : null;
}
const inLinePrice = new Set(((item && item.line_level_discount_allocations) || []).map((a) => a.discount_application.title));
const extra = ((item && item.discounts) || []).filter((d) => d.amount > 0 && !inLinePrice.has(d.title));
if (!extra.length) {
row.querySelectorAll('.tsc-line-discounts').forEach((el) => el.remove());
continue;
}
const html = extra.map((d) => `<span>${esc(d.title)} −${money(d.amount, cart.currency)}</span>`).join('');
const wrappers = row.querySelectorAll('.cart-item__price-wrapper');
const anchors = wrappers.length ? [...wrappers] : [row.querySelector('.cart-item__totals') || row];
for (const anchor of anchors) {
let box = anchor.querySelector(':scope > .tsc-line-discounts');
if (!box) {
box = document.createElement('div');
box.className = 'tsc-line-discounts';
anchor.append(box);
}
if (box.dataset.html !== html) {
box.innerHTML = html;
box.dataset.html = html;
}
}
}
}

async function render() {
const scopes = [...document.querySelectorAll(SCOPES)];
if (!scopes.length) return;
const now = Date.now();
if (!cached || now - lastFetch > MIN_GAP) {
try {
const res = await fetch('/cart.js', { credentials: 'same-origin' });
if (!res.ok) return;
cached = await res.json();
lastFetch = Date.now();
} catch { return; }
}
if (!cached || !cached.items) return;
for (const scope of scopes) paint(scope, cached);
paintLines(cached);
}

function schedule(fresh) {
if (fresh) cached = null;
clearTimeout(timer);
timer = setTimeout(render, 250);
}

// Anything that rewrites the cart (theme, Discount Ninja, quantity changes) shows
// up as DOM churn; ignore our own writes so this can't loop.
new MutationObserver((records) => {
if (records.every((r) => r.target.closest && r.target.closest('.tsc-totals, .tsc-line-discounts'))) return;
schedule(true);
}).observe(document.documentElement, { childList: true, subtree: true });

styles();
document.addEventListener('DOMContentLoaded', () => schedule(true));
schedule(true);
setTimeout(() => schedule(true), 1500);
})();